import data from '@emoji-mart/data'

function getEmoji(id: string) {
  const emoji = data.emojis[id]

  return (emoji && emoji.skins[0].native) || ''
}

const emotRegex = new RegExp(
  `(\\s|^)(${Object.keys(data.emoticons)
    .map(emot =>
      emot
        .split('')
        .map(char => (/[\w-:]/.test(char) ? char : `\\${char}`))
        .join(''),
    )
    .join('|')})(\\s)`,
  'g',
)

const colonRegex = /:([\w-]+):/g

export const replaceEmojis = (text: string, all = false) => {
  const replaced = (all ? `${text} ` : text)
    .replace(
      emotRegex,
      (_, s1, match, s2) => `${s1}${getEmoji(data.emoticons[match])}${s2}`,
    )
    .replace(colonRegex, (match, id) => getEmoji(id) || match)
  return all ? replaced.replace(/ $/, '') : replaced
}
